import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Loading from "../../Components/Loading/Loading";
import ShowCard from "../../Components/ShowCard/ShowCard";
import { ToastContainer, toast } from "react-toastify";
import { useWindowWidth } from "@react-hook/window-size";
import Translate from "../../Components/Multilanguage/Translate";

import { rowItemCount } from "../../utils/utils";

const PlaylistPage = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const isRTL = useSelector((state) => state?.rtl?.isRTL);
  const [shows, setShows] = useState([]);
  const [playlistTitle, setPlaylistTitle] = useState("");
  const [loading, setLoading] = useState(true);
  const [thumbnailOrientation, setThumbnailOrientation] = useState("");
  const [rowItemsClass, setRowItemsClass] = useState("");
  const template = projectInfo?.projectConfig?.config?.TEMPLATE;

  const location = useLocation();
  const navigate = useNavigate();
  const { playlistId } = useParams();
  const windowSize = useWindowWidth();

  useEffect(() => {
    if (
      projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION === "PORTRAIT"
    ) {
      setThumbnailOrientation("PORTRAIT");
    } else {
      setThumbnailOrientation("LANDSCAPE");
    }
  }, [projectInfo]);

  useEffect(() => {
    if (windowSize > 980) {
      if (projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT) {
        setRowItemsClass(rowItemCount(projectInfo?.projectConfig?.config?.WEBSITE_ROW_ITEM_COUNT));
      } else {
        setRowItemsClass("rowCount4");
      }
    } else {
      setRowItemsClass("");
    }
  }, [projectInfo, windowSize]);

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  useEffect(() => {
    const playlistData = location.state?.playlistData;
    
    if (playlistData) {
      setShows(playlistData.shows || []);
      setPlaylistTitle(playlistData.title || "");
      setLoading(false);
    } else {
      navigate("/my-list");
    }
  }, [location.state, navigate]);

  if (loading) {
    return <Loading />;
  }

  return (
    <div className={`myList ${isRTL ? "rtl" : ""}`}>
      <ToastContainer />

      <div className="wrapper">
        <div className="top">
          <h1 className={`heading ${template === "TEMPLATE_10" ? "gaia" : ""}`}>
            {playlistTitle || <Translate textKey={'my_list'} />}
          </h1>
        </div>
        <div className="bottom">
          <div className="itemsContainer">
            {shows?.map((item, index) => (
              <div 
                key={index}
                className={thumbnailOrientation === `PORTRAIT` ? `items portrait ${rowItemsClass}` : `items landscape ${rowItemsClass}`}
              >
                <ShowCard
                  data={item}
                  imageUrl={true}
                  season={false}
                  metaData={true}
                  modalNavigation={true}
                  showMyListButton={true}
                />
              </div>
            ))}
          </div>
          {shows?.length === 0 && (
            <div className="favourite-empty-state">
              <h2><Translate text="no_data_found" /></h2>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PlaylistPage;